import * as types from './documents.types';

function getDocuments() {
  return { type: types.FETCH_DOCUMENTS };
}

export { getDocuments };
